import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DoctorService {


  url = environment.serverAPI4 + "/api/doctorIdx";

  url1 = environment.serverAPI + "/api/doctor/approve";

  constructor(private http: HttpClient) { }

  getAllDoctor(Page: any, size: any, sort: any , supplierType:any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  getAllDoctorDropDown(supplierType:any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?typeId=${supplierType}`);
  }


  getDoctorById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditDoctor(lecturerIdx: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, lecturerIdx);
  }

  DoctorSearch(query, Page: any, size: any, sort: any , supplierType:any ): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  downDoctorReportTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downDoctorReport() {
    return this.http.get(`${this.url}/exceltemplate/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getApproved(supplier: any): Observable<Object> {
    return this.http.post(`${this.url1}`, supplier);
  }
  
}
